const data = {
  deviceStatus:['','运行','停运','故障'],
  holidays: ['班', '休'],
  statuses: ['已创建', '待审核', '未开始', '进行中', '已完成', '', '', '', '拒审核', '已作废', '已删除'],
  taskMaterialStatus: ['待提交', '待审核', '已领料'],
  logMethods: ['', '增加', '编辑', '删除', '', '', '', '', '', '', '', '登录帐号', '修改密码', ''],
  logScenes: {
    'admin': '管理员',
    'admin_goup': '管理角色',
    'admin_menu': '管理权限',
    'task': '任务'
  }
}
export default {
  data
}